import { render, staticRenderFns } from "./AccountHolderNotes.vue?vue&type=template&id=656eb30b&scoped=true"
import script from "./AccountHolderNotes.vue?vue&type=script&lang=ts"
export * from "./AccountHolderNotes.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderNotes.vue?vue&type=style&index=0&id=656eb30b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656eb30b",
  null
  
)

export default component.exports